import { http } from "./http";

async function createCombinationPhase(id, phase) {
  const response = await http.post(`shippings/${id}/combination-phases`, phase);
  return response.data;
}

async function updateCombinationPhase(id, phaseId, phase, fromRoute) {
  const response = await http.put(
    `shippings/${id}/phases/${phaseId}/combination-phases${
      fromRoute ? "/from-routes" : ""
    }`,
    phase,
  );
  return response;
}

async function updatePhasesState(id, valueId, stateId) {
  const response = await http.patch(`shippings/${id}/phases/${valueId}/state`, {
    value: stateId,
  });
  return response;
}

async function createNonStandardPhase(id, phase) {
  const response = await http.post(`shippings/${id}/nonstandart-phases`, phase);
  return response.data;
}

async function updateNonStandardPhase(id, phaseId, phase) {
  const response = await http.put(
    `shippings/${id}/phases/${phaseId}/nonstandart-phases`,
    phase,
  );
  return response;
}

async function createPickupPhase(id, phase) {
  const response = await http.post(`shippings/${id}/pickup-phases`, phase);
  return response.data;
}

async function updatePickupPhase(id, value, phase, fromRoute) {
  const response = await http.put(
    `shippings/${id}/phases/${value}/pickup-phases${
      fromRoute ? "/from-routes" : ""
    }`,
    phase,
  );
  return response;
}

async function getPhases(id) {
  const response = await http.get(`shippings/${id}/phases`);
  return response.data.map(p => {
    return {
      id: p.Id,
      state: {
        id: p.State.Id,
        title: p.State.Title,
      },
      type: {
        id: p.Type.Id,
        title: p.Type.Title,
      },
      arrivalPoint: {
        address: p.ArrivalPoint.Address
          ? {
            id: p.ArrivalPoint.Address.Id,
            title: p.ArrivalPoint.Address.Title,
          }
          : null,
        factory: p.ArrivalPoint.Factory
          ? {
            id: p.ArrivalPoint.Factory.Id,
            title: p.ArrivalPoint.Factory.Title,
          }
          : null,
        warehouse: p.ArrivalPoint.Warehouse
          ? {
            id: p.ArrivalPoint.Warehouse.Id,
            title: p.ArrivalPoint.Warehouse.Title,
          }
          : null,
      },
      unloadingDate: p.UnloadingDate,
      sendingPoint: {
        address: p.SendingPoint.Address
          ? {
            id: p.SendingPoint.Address.Id,
            title: p.SendingPoint.Address.Title,
          }
          : null,
        factory: p.SendingPoint.Factory
          ? {
            id: p.SendingPoint.Factory.Id,
            title: p.SendingPoint.Factory.Title,
          }
          : null,
        warehouse: p.SendingPoint.Warehouse
          ? {
            id: p.SendingPoint.Warehouse.Id,
            title: p.SendingPoint.Warehouse.Title,
          }
          : null,
      },
      isCrossingUkrainianBorder: p.IsCrossingUkrainianBorder,
      isLast: p.IsLast,
      route: p.Route
        ? {
          id: p.Route.Id,
          title: p.Route.Title,
          state: p.Route.State
            ? {
              id: p.Route.State.Id,
              title: p.Route.State.Title,
            }
            : null,
        }
        : null,
      vehicle: p.Vehicle
        ? {
          id: p.Vehicle.Id,
          title: p.Vehicle.Title,
        }
        : null,
      hasRerouting: p.HasRerouting,
      hasUnreadNotes: p.HasUnreadNotes,
      allowEditing: p.AllowEditing,
      inCar: p.InCar,
      counterparty: p.Counterparty
        ? {
          id: p.Counterparty.Id,
          title: p.Counterparty.Title,
        } : null,
    };
  });
}

async function getPhaseId(id, phaseId) {
  const res = await http.get(`shippings/${id}/phases/${phaseId}`);
  return {
    id: res.data.Id,
    state: {
      id: res.data.State.Id,
      title: res.data.State.Title,
    },
    type: {
      id: res.data.Type.Id,
      title: res.data.Type.Title,
    },
    unloadingDate: res.data.UnloadingDate,
    loadingDate: res.data.LoadingDate,
    readyForCombination: res.data.ReadyForCombination,
    transportTypes: res.data.TransportTypes
      ? res.data.TransportTypes.map(i => {
        return {
          id: i.Id,
          title:
              i.Id === 0
                ? "Авиа"
                : i.Id === 1
                  ? "Авто"
                  : i.Id === 2
                    ? "ЖД"
                    : "Море",
        };
      })
      : null,
    comments: res.data.Notes
      ? res.data.Notes.map(c => {
        return {
          id: c.Id,
          createdAt: c.CreatedAt,
          author: {
            id: c.Author.Id,
            title: c.Author.Title,
          },
          text: c.Text,
          isReaded: c.IsReaded,
          context: c.Context,
          readedDate: c.ReadedDate,
        };
      })
      : [],
    counterparty: res.data.Counterparty
      ? {
        carrier: res.data.Counterparty.Carrier
          ? {
            id: res.data.Counterparty.Carrier.Id,
            title: res.data.Counterparty.Carrier.Title,
          }
          : null,
        client: res.data.Counterparty.Client
          ? {
            id: res.data.Counterparty.Client.Id,
            title: res.data.Counterparty.Client.Title,
          }
          : null,
        warehouse: res.data.Counterparty.Warehouse
          ? {
            id: res.data.Counterparty.Warehouse.Id,
            title: res.data.Counterparty.Warehouse.Title,
          }
          : null,
      }
      : null,
    arrivalPoint: {
      address: res.data.ArrivalPoint.Address
        ? {
          id: res.data.ArrivalPoint.Address.Id,
          title: res.data.ArrivalPoint.Address.Title,
        }
        : null,
      factory: res.data.ArrivalPoint.Factory
        ? {
          id: res.data.ArrivalPoint.Factory.Id,
          title: res.data.ArrivalPoint.Factory.Title,
        }
        : null,
      warehouse: res.data.ArrivalPoint.Warehouse
        ? {
          id: res.data.ArrivalPoint.Warehouse.Id,
          title: res.data.ArrivalPoint.Warehouse.Title,
          groupedWarehouse: res.data.ArrivalPoint.Warehouse.GroupedWarehouse,
        }
        : null,
    },
    sendingPoint: {
      address: res.data.SendingPoint.Address
        ? {
          id: res.data.SendingPoint.Address.Id,
          title: res.data.SendingPoint.Address.Title,
        }
        : null,
      factory: res.data.SendingPoint.Factory
        ? {
          id: res.data.SendingPoint.Factory.Id,
          title: res.data.SendingPoint.Factory.Title,
        }
        : null,
      warehouse: res.data.SendingPoint.Warehouse
        ? {
          id: res.data.SendingPoint.Warehouse.Id,
          title: res.data.SendingPoint.Warehouse.Title,
        }
        : null,
    },
    route: res.data.Route
      ? {
        id: res.data.Route.Id,
        title: res.data.Route.Title,
      }
      : null,
    vehicle: res.data.Vehicle
      ? {
        id: res.data.Vehicle.Id,
        title: res.data.Vehicle.Title,
      }
      : null,
    inCar: res.data.InCar,
    isLast: res.data.IsLast,
    isLastPhaseDone: res.data.IsLastPhaseDone,
    allowEditing: res.data.AllowEditing,
    allowChangeState: res.data.AllowChangeState,
  };
}

async function markAsReadComments(shippingId, phasesId, commentsId) {
  const response = await http.patch(
    `shippings/${shippingId}/phases/${phasesId}/notes/mark-as-read`,
    {
      value: commentsId,
    },
  );
  return response;
}

async function deletePhase(id, phaseId) {
  await http.delete(`shippings/${id}/phases/${phaseId}`);
}

async function unmarkPhasesWithRerouting(shippingId, phaseId) {
  await http.delete(`shippings/${shippingId}/phases/${phaseId}/rerouting`);
}

async function addComment(id, comment, fromRoute) {
  const result = await http.post(
    `shippings/phases/${id}/notes${fromRoute ? "/from-routes" : ""}`,
    { value: comment },
  );
  return result;
}

async function getPhasesComments(id, phaseId) {
  const result = await http.get(`shippings/${id}/phases/${phaseId}/notes`);
  return result.data.map(c => {
    return {
      id: c.Id,
      createdAt: c.CreatedAt,
      author: {
        id: c.Author.Id,
        title: c.Author.Title,
      },
      text: c.Text,
      isReaded: c.IsReaded,
      context: c.Context,
      readedDate: c.ReadedDate,
    };
  });
}

async function deletePhasesComment(phaseId, phaseNoteId) {
  await http.delete(`shippings/phases/${phaseId}/notes/${phaseNoteId}`);
}

export {
  createCombinationPhase,
  updateCombinationPhase,
  updatePhasesState,
  createNonStandardPhase,
  updateNonStandardPhase,
  createPickupPhase,
  updatePickupPhase,
  getPhases,
  getPhaseId,
  markAsReadComments,
  deletePhase,
  unmarkPhasesWithRerouting,
  addComment,
  getPhasesComments,
  deletePhasesComment,
};
